import { render, staticRenderFns } from "./centerTop.vue?vue&type=template&id=653b682c&scoped=true"
import script from "./centerTop.vue?vue&type=script&lang=js"
export * from "./centerTop.vue?vue&type=script&lang=js"
import style0 from "./centerTop.vue?vue&type=style&index=0&id=653b682c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b682c",
  null
  
)

export default component.exports